export type SaveOptions = { andExitEdit: boolean; andNotify: boolean };
export const defaultSaveOptions: SaveOptions = {
  andExitEdit: false,
  andNotify: true,
};
